import {ACTION} from './constants';
let initialState={};

export default function SurveyReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.SURVEY_USER :
            return {...state, user:{...action.data}};
        default:
            return state;
    }
};